import { defineMessages } from 'react-intl';

const messages = defineMessages({
  walletBalanceHeader: {
    description: 'Header for wallet balance card',
    defaultMessage: ' ShipStation Balance',
    id: 'j1+GXr',
  },
  walletCardNote: {
    description: 'Note that explains what the ShipStation Balance pays for',
    defaultMessage: 'Pay for Labels and related fees',
    id: 'dV1k7y',
  },
  setupWalletCardNote: {
    description: 'Note that explains what ShipStation Balance is and its perks',
    defaultMessage: "Buy labels with ShipStation's best rates",
    id: 'Hd1dWS',
  },
  walletCardManageAutoFund: {
    description: 'link to auto funding in wallet balance card when auto funding is enabled',
    defaultMessage: 'Manage Auto-funding',
    id: '3ybJJ/',
  },
  walletCardAutoFundLink: {
    description: 'link to auto funding in wallet balance card',
    defaultMessage: 'Add funds automatically',
    id: 'L8XdU8',
  },
  walletBalanceSubTitle: {
    description: 'Wallet card sub title for add funds section',
    defaultMessage: 'Add Funds',
    id: 'dwAe1e',
  },
  walletBalanceCardSetup: {
    description: 'Note to users to buy labels',
    defaultMessage: 'Complete setup to benefit from the best rates. <link>Get Started</link>',
    id: 'gP/hYy',
  },
});

export default messages;
